import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import myConnections from "../../utility/connect";

const sliceName = "dictionarySlice";
const stateName = "dictionaryState";

const initialState = {
  dictionaryLoaded: false,
  languages: [],
  translations: {},
};

let getTranslations = async (_, thunkAPI) => {
  const response = await myConnections.get({
    path: "sifrarnici/get_translations",
    data: {},
    headers: {},
    thunkAPI: thunkAPI,
  });

  return response;
};

getTranslations = createAsyncThunk(
  `${sliceName}/getTranslations`,
  getTranslations
);
getTranslations.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {
    state.dictionaryLoaded = true;
    const translationsObradeno = {};
    const translationsFromDB = action.payload.items[0].translations;

    const primaryLang = action.payload.items[0].primary_lang;
    const secondaryLang = action.payload.items[0].secondary_lang;

    if (primaryLang != null) {
      state.languages.push(primaryLang);
      translationsObradeno[primaryLang] = {};
      translationsObradeno[primaryLang]["fullName"] =
        action.payload.items[0].primary_lang_full;
      translationsObradeno[primaryLang]["shortName"] =
        action.payload.items[0].primary_lang_short;
      translationsObradeno[primaryLang]["translations"] = {};
      translationsObradeno[primaryLang]["isPrimaryLang"] = true;
    }
    if (secondaryLang != null) {
      state.languages.push(secondaryLang);
      translationsObradeno[secondaryLang] = {};
      translationsObradeno[secondaryLang]["fullName"] =
        action.payload.items[0].secondary_lang_full;
      translationsObradeno[secondaryLang]["shortName"] =
        action.payload.items[0].secondary_lang_short;
      translationsObradeno[secondaryLang]["translations"] = {};
      translationsObradeno[secondaryLang]["isPrimaryLang"] = false;
    }

    translationsFromDB.forEach((element) => {
      const key = element.code;
      const primaryValue = element.value;
      const secondaryValue = element.value_lang;
      if (primaryLang) {
        translationsObradeno[primaryLang]["translations"][key] = primaryValue;
      }
      if (secondaryLang) {
        translationsObradeno[secondaryLang]["translations"][key] =
          secondaryValue;
      }
    });

    state.translations = translationsObradeno;
  },
  rejected: (state, action) => {},
};

const dictionarySlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTranslations.pending, getTranslations.myLC.pending);
    builder.addCase(getTranslations.fulfilled, getTranslations.myLC.fulfilled);
    builder.addCase(getTranslations.rejected, getTranslations.myLC.rejected);
  },
});



export const getters = {
  isDictionaryLoaded : state => state[stateName].dictionaryLoaded 
};

export const asyncActions = { getTranslations };
export const actions = dictionarySlice.actions;
export default dictionarySlice.reducer;
